import { BaseInput, InputSize } from "shared/components/forms/BaseInput";

type AssigneeSearchInputProps = {
  id: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  autoFocus?: boolean;
};

export const AssigneeSearchInput = ({
  id,
  placeholder,
  value,
  onChange,
  onKeyDown,
  onBlur,
  autoFocus
}: AssigneeSearchInputProps) => {
  return (
    <div className="px-4 py-2.5 border-b border-alpha-40">
      <BaseInput
        id={id}
        placeholder={placeholder}
        size={InputSize.SM}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        autoFocus={autoFocus}
      />
    </div>
  );
};
